import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpErrorResponse, HttpEvent } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { AuthenticationService } from './authentication.service';
import { environment } from 'src/environments/environment';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class BasicAuthHtppInterceptorService implements HttpInterceptor {
  private currentRoute: string = '/';

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router
  ) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.currentRoute = event.urlAfterRedirects.split('?')[0];
    });
  }

  private publicEndpoints = [
    environment.BasePath + '/authenticate',
    environment.BasePath + '/authenticate/mfa',
    environment.BasePath + '/survey/reset-password',
    environment.BasePath + '/survey/forgot-password',
    environment.BasePath + '/survey/createAcount',
    environment.BasePath + '/register',
    environment.BasePath + '/register-user',
    environment.BasePath + '/survey/reset-password-user',
    environment.BasePath + '/success',
    environment.BasePath + '/fail'
  ];

  private publicRoutes = [
    '/login',
    '/register',
    '/register-user',
    '/reset-password',
    '/email-verification',
    '/success',
    '/fail',
    '/reset-password-user',
    '/auth/login',
    '/auth/register',
    '/auth/register-user',
    '/auth/reset-password',
    '/auth/email-verification',
    '/auth/reset-password-user'
  ];

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isPublicEndpoint = this.publicEndpoints.some(endpoint => req.url.startsWith(endpoint));
    const isPublicRoute = this.publicRoutes.some(route => this.currentRoute === route);
    const isStaticAsset = req.url.includes('/assets/');
    const isFileUpload = req.body instanceof FormData;

    if (isStaticAsset) {
      return next.handle(req);
    }

    if (isPublicEndpoint) {
      return next.handle(req).pipe(
        catchError((error: HttpErrorResponse) => {
          return throwError(error);
        })
      );
    }

    if (isPublicRoute) {
      return next.handle(req).pipe(
        catchError((error: HttpErrorResponse) => {
          return throwError(error);
        })
      );
    }

    if (sessionStorage.getItem('username') && sessionStorage.getItem('token')) {
      const token = sessionStorage.getItem('token') || '';
      const etablissement = sessionStorage.getItem('etablissement') ? JSON.parse(sessionStorage.getItem('etablissement') || '{}') : null;
      const authUser = JSON.parse(sessionStorage.getItem('authUser') || '{}');

      const authToken = token.startsWith('Bearer ') ? token : `Bearer ${token}`;
      
      let headers = req.headers.set('Authorization', authToken);
      
      if (etablissement?.id) {
        headers = headers.set('idEtab', etablissement.id.toString());
      }
      
      if (authUser?.id) {
        headers = headers.set('idUser', authUser.id.toString());
      }

      let newReq = req.clone({ headers });

      if (newReq.url.startsWith(environment.BasePath + '/survey/print/')) {
        newReq = newReq.clone({ responseType: 'blob' });
      }

      if (!isFileUpload && newReq.body && etablissement?.id) {
        newReq = newReq.clone({
          body: { ...newReq.body, idEtab: etablissement.id }
        });
      }

      return next.handle(newReq).pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.status === 401 || (error.error && typeof error.error === 'string' && error.error.includes('JWT signature'))) {
            this.authenticationService.logOut();
            this.router.navigate(['/auth/login'], { queryParams: { expired: 'true' } });
          }
          return throwError(error);
        })
      );
    }

    if (this.currentRoute === '/') {
      return next.handle(req);
    }

    this.authenticationService.logOut();
    this.router.navigate(['/auth/login']);
    return throwError(new Error('Utilisateur non authentifié'));
  }
}
